import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Establishes the first snapshot as a baseline so opening a projection link
 * never replays an old roll. Every new public roll id is then shown once.
 */
export const useRemoteDiceRoll = (sourceKey) => {
  const [activeRoll, setActiveRoll] = useState(null);
  const hasBaselineRef = useRef(false);
  const lastRollIdRef = useRef(null);

  useEffect(() => {
    hasBaselineRef.current = false;
    lastRollIdRef.current = null;
    setActiveRoll(null);
  }, [sourceKey]);

  const observeRoll = useCallback((roll) => {
    const rollId = roll?.id || null;

    if (!hasBaselineRef.current) {
      hasBaselineRef.current = true;
      lastRollIdRef.current = rollId;
      return;
    }

    if (!rollId || rollId === lastRollIdRef.current) return;

    lastRollIdRef.current = rollId;
    setActiveRoll(roll);
  }, []);

  const clearActiveRoll = useCallback(() => setActiveRoll(null), []);

  return { activeRoll, observeRoll, clearActiveRoll };
};
